import React, { Suspense, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';

import LoadingScreen from '../../../components/LoadingScreen';
import * as ROUTES from '../../../constants/routes';

const ViewChildComponent = React.lazy(() => import('./components/ViewChild'));

const mapChild = (kid) => ({
  id: kid?.id,
  userId: kid?.user_id,
  profileImage: kid?.profile_image ? kid?.profile_image : '',
  name: `${kid.first_name} ${kid?.last_name}`,
  gender: kid?.gender,
  email: kid?.email ? kid?.email : 'N/A',
  phone: kid?.phone ? kid?.phone : 'N/A',
  dob: kid?.dob,
  parentId: kid?.parent_id,
  parentUserProfileId: kid?.parent?.id,
  parentName: kid?.parent?.first_name
    ? `${kid?.parent.first_name} ${kid?.parent?.last_name}`
    : 'N/A',
  attachmentIds: kid?.attachment_ids,
  createdAt: kid?.created_at,
  user: kid?.user,
});

const ViewChild = () => {
  const { id } = useParams();
  const { pathname } = useLocation();

  const store = useSelector((state) => ({
    kidsList: state.app.kidsList,
  }), shallowEqual);

  const [child, setChild] = useState(
    store.kidsList.find((c) => id === c.id)
  );
  const [loading, setLoading] = useState(!child);

  useEffect(() => {
    const fetchChild = async () => {
      try {
        const authToken = JSON.parse(localStorage.getItem(process.env.REACT_APP_ADMIN_AUTH_TOKEN));
        const response = await fetch(`${ROUTES.ADMIN_API}/users/kids/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${authToken.token}`,
          },
        });
        const data = await response.json();
        if (data?.data) {
          setChild(mapChild(data.data));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (!child) {
      fetchChild();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      {loading ? (
        <LoadingScreen isDashboard={pathname.includes('/dashboard')} />
      ) : (
        child && (
          <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
            <ViewChildComponent child={child} />
          </Suspense>
        )
      )}
    </>
  );
};

export default ViewChild;
